import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";
import {IDashboardPageNotesPlayedTimeRangeSection} from "../store/IDashboardPageStore";

export interface INotesPlayedLogic {
  correctNotes?: IDashboardPageNotesPlayedTimeRangeSection;
  closeNotes?: IDashboardPageNotesPlayedTimeRangeSection;
  incorrectNotes?: IDashboardPageNotesPlayedTimeRangeSection;
  totalNotes?: IDashboardPageNotesPlayedTimeRangeSection;
  percentCorrect?: IDashboardPageNotesPlayedTimeRangeSection;
}

export const useNotesPlayedLogic = (): INotesPlayedLogic => {
  const {correctNotes, closeNotes, incorrectNotes, totalNotes, percentCorrect} = useAppSelector(dashboardStore.getNotesPlayedBySelectedRangeData);
  return {
    correctNotes,
    closeNotes,
    incorrectNotes,
    totalNotes,
    percentCorrect,
  }
}
